import axios from '@/utils/request'
var Qs = require('qs')

export default {
	// 2021-10-20
	search(params) {
		return axios.get('/weddingDressHall/rent/search?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
	},
	// 2021-10-06
	findBySerialNo(params) {
		return axios.get('/weddingDressHall/rent/find-by-serial-no', params);
	},
	// 2021-10-06
	create(params) {
		return axios.post('/weddingDressHall/rent', params);
	},
	// 2021-11-29
	insertClean(params) {
		return axios.post('/weddingDressHall/rent/insert-clean', params);
	},
	// 2021-10-06
	delete(id) {
		return axios.delete('/weddingDressHall/rent/' + id)
	},
	// 2021-10-06
	update(id, params) {
		return axios.put('/weddingDressHall/rent/' + id, params);
	},
	// 2021-10-21
	updateAmount(id, params) {
		return axios.put('/weddingDressHall/rent/' + id + '/update-amount', params);
	},
	// 2021-10-06
	updataOwner(id, params) {
		return axios.put('/weddingDressHall/rent/' + id + '/update-owner', params);
	},
	// 2021-10-06
	exportExcel(params) {
		return axios.get('/weddingDressHall/rent/export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
	},

	// 2021-10-11
	finish(id, params) {
		return axios.put('/weddingDressHall/rent/' + id + '/finish', params);
	},
	// 2021-10-08
	out(id, params) {
		return axios.put('/weddingDressHall/rent/' + id + '/out', params);
	},
	// 2021-11-12
	delivery(id, params) {
		return axios.put('/weddingDressHall/rent/' + id + '/delivery', params);
	},
	// 2021-10-08
	returnDepoist(id, params) {
		return axios.put('/weddingDressHall/rent/' + id + '/return-depoist', params);
	},
	// 2021-11-29
	depoistToPay(id, params) {
		return axios.put('/weddingDressHall/rent/' + id + '/depoist-to-pay', params);
	},
	// 2021-11-29
	serviceNames() {
		return axios.get('/weddingDressHall/rent/service-name')
	},

	// 2021-10-11
	workbench() {
		return axios.get('/weddingDressHall/rent/workbench');
	},
	// 2022-01-21
	workbenchNear() {
		return axios.get('/weddingDressHall/rent/workbench-near');
	},
	// 2022-01-21
	workbenchOver() {
		return axios.get('/weddingDressHall/rent/workbench-over');
	},
	// 2022-01-21
	newlyCalendar() {
		return axios.get('/weddingDressHall/rent/newly-calendar');
	},

	// 2023-04-03
	addDepoist(id, params) {
		return axios.put('/weddingDressHall/rent/' + id + '/add-depoist', params);
	},
	// 2021-10-06
	findById(id) {
		return axios.get('/weddingDressHall/rent/' + id);
	},
}

